module.exports = __webpack_public_path__ + "img/pulse_v1_icon.e6b07276.png";